<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('title.regcourse') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="12">
              <h2 class="text-md-h4 font-weight-bold sub-title-page">
                {{ $t('title.regcourse') }}
              </h2>
            </v-col>
            <v-col cols="12" md="12">
              <p v-if="$i18n.locale === 'en'">
                We offer several degree programs: D3, D4, masters, and doctoral programs in engineering and commerce.
              </p>
              <p v-if="$i18n.locale === 'id'">
                Kami menawarkan beberapa program gelar: D3, D4, program magister, dan doktoral di bidang teknik dan niaga.
              </p>
              <v-row class="black--text mb-5" v-if="datalist">
                <v-col
                  class="d-flex"
                  cols="12"
                  md="3"
                  v-for="(prodi, i) in datalist"
                  :key="i">
                  <v-card
                    class="d-flex flex-column w100"
                    :to="{ name: 'Prodi', params: { slug: prodi.slug_prodi }}"
                    exact>
                    <v-card-text class="text--primary flex-grow-1 flex-shrink-0 ma-0 py-2">
                      <div class="d-flex py-2">
                        <div class="d-inline mr-3">
                          <v-img
                            max-height="80"
                            max-width="80"
                            :src="prodi.urlpic ? prodi.urlpic : ''">
                          </v-img>
                        </div>
                        <div class="d-inline">
                          <div class="line-h-normal font-weight-bold text-mcolor">
                            {{ prodi.nama_prodi }}
                          </div>
                          <div class="caption">{{ prodi.nama_jur }}</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-btn
                :color="maincolor"
                class="white--text"
                :to="{ name: 'NewsDetail', query: { berita: 25 } }">
                {{ $t('button.enroll') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid fill-height class="py-10 min-height-pages bacground-maincolor">
      <v-container class="px-0 px-md-3">
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursereg' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.regcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courseint' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.intcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursecoop' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.coopcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Courserpl' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.rplcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              tile
              flat
              :to="{ name: 'Coursespe' }">
              <v-card-title class="font-weight-bold">
                <div>
                  {{ $t('title.specialcourse') }}
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  :color="maincolor">
                  mdi-open-in-new
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="d-flex flex-column w100">
            <v-img
              class="white--text align-end flex-grow-0 flex-shrink-1"
              height="225px"
              :src="news.urlpic">
            </v-img>
            <v-card-subtitle>
              <h1 class="title font-weight-bold mb-3">
                <router-link class="text-decoration-none text-ellipsis--2"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="news.tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="news.tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ news.cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                  :title="news.judul_berita"
                  :description="news.prev_berita"
                  :quote="news.prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
            </v-card-subtitle>
            <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions v-if="false">
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'News', query: { type: 'berita', category: 'pendidikan' } }"
            exact>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Coursereg',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/reg-class.jpeg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
    this.getProdi();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    updateLanguage() {
      this.getBerita();
    },
    getProdi() {
      this.datalist = [];
      this.axios
        .get(
          this.api + '/public/prodiall',
          {
            params: {},
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.img_prodi) {
                  element.urlpic = this.api + '/upload/jurusan/' + element.img_prodi;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.datalist.push(element);
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
